// Copyright (c) 2016 Deere & Company

import DuplicatePinPlateReport from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate-report';
import t from 'tcomb';

const Report = t.list(DuplicatePinPlateReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/state/report.js